"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessengerService = (function () {
    function MessengerService(window) {
        this.registeredCommands = {};
        window.addEventListener('message', this.onMessageReceived.bind(this));
    }
    MessengerService.getInstance = function (context) {
        if (!this.messengerInstance) {
            this.messengerInstance = new MessengerService(context);
        }
        return this.messengerInstance;
    };
    MessengerService.prototype.onMessageReceived = function (event) {
        var callbacksList = this.registeredCommands[event.data.command];
        if (!callbacksList) {
            return;
        }
        callbacksList.forEach(function (callback) {
            callback(event);
        });
    };
    MessengerService.prototype.registerCommand = function (commandName, callback) {
        if (!this.registeredCommands[commandName]) {
            this.registeredCommands[commandName] = [];
        }
        this.registeredCommands[commandName].push(callback);
    };
    MessengerService.prototype.sendMessage = function (message) {
        window.top.postMessage(message, '*');
    };
    return MessengerService;
}());
exports.MessengerService = MessengerService;
